import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useAsu } from "@framework/provider-asu";

import { emptyFilters } from "../../../common/interfaces/empty-filters";

export const FormReset: FC = () => {
  const form = useFormContext();
  const { isFilterApplied } = useAsu();

  useEffect(() => {
    if (!isFilterApplied) {
      form.reset(emptyFilters);
    }
  }, [isFilterApplied]);

  return null;
};
